module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nb-pager-selection"
  }, [_c('div', {
    staticClass: "title-area clearfix"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.activeScenery.name ? "#" + _vm.activeScenery.id + " " + _vm.activeScenery.name : "请选择定制页面...") + "\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm ml15",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [(_vm.show) ? _c('span', [_c('i', {
    staticClass: "fa fa-angle-up"
  }), _vm._v("\n\t\t\t\t收起\n          ")]) : _c('span', [_c('i', {
    staticClass: "fa fa-angle-down"
  }), _vm._v("\n\t\t\t\t选择\n        ")])])]), _vm._v(" "), _c('NbExpanding', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('div', {
    staticClass: "content-area"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.sceneryList), function(scenery) {
    return _c('div', {
      staticClass: "p10 mt10 br4 cursor border",
      class: {
        'bg-white': scenery.id !== _vm.activeScenery.id, 'bg-azure': scenery.id === _vm.activeScenery.id
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.clickItem(scenery)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "pull-left"
    }), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('div', [_c('span', {
      staticClass: "f15"
    }, [_vm._v(_vm._s(scenery.name))])]), _vm._v(" "), _c('div', {
      staticClass: "mv5"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scenery.description) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "mv5"
    }, [_c('span', [_vm._v("编号：" + _vm._s(scenery.id))])])])])])])])
  }), 0)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c3a1741e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/scenery/Selection.vue
// module id = 1022
// module chunks = 1